import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { guardarNotificacion } from "./NotificadorALQOS";

const meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

export default function PortalEmpleado({ usuario, oscuro, onCerrarSesion, onVolver }) {
  const [seccion,   setSeccion]   = useState("pendientes");
  const [recibos,   setRecibos]   = useState([]);
  const [docs,      setDocs]      = useState([]);
  const [comunicados, setComunicados] = useState([]);
  const [onboarding, setOnboarding] = useState(null);
  const [empleado,  setEmpleado]  = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [firmando,  setFirmando]  = useState(null);
  const [discId,    setDiscId]    = useState(null);
  const [motivoDisc, setMotivoDisc] = useState("");
  const [verRecibo, setVerRecibo] = useState(null);
  const [verUrl,    setVerUrl]    = useState(null);
  const [verTitulo, setVerTitulo] = useState(null);
  const [cargandoVer, setCargandoVer] = useState(false);
  const [subiendo,  setSubiendo]  = useState(false);
  const [formDoc,   setFormDoc]   = useState({ tipo:"", descripcion:"", vencimiento:"" });
  const [desbloqueado, setDesbloqueado] = useState(() => usuario?.rol === "Empleado" || usuario?.rol === "Administrador");
  const [claveInput,   setClaveInput]   = useState("");
  const [claveConfirm, setClaveConfirm] = useState("");
  const [errorClave,   setErrorClave]   = useState("");

  const C = {
    bg:     "#F0EEFF",
    card:   "#ffffff",
    navy:   "#09184D",
    purple: "#7B5BF2",
    blue:   "#2A7FFF",
    green:  "#22c55e",
    amber:  "#f59e0b",
    red:    "#e63946",
    sub:    "#808085",
    border: "#dde3f0",
    text:   "#2F3E2E",
  };

  const inp = { width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"13px", boxSizing:"border-box", marginTop:"6px", background:"white", color:C.text, outline:"none", fontFamily:"sans-serif" };
  const lbl = { fontSize:"11px", color:C.sub, fontWeight:"700", display:"block", marginTop:"14px", textTransform:"uppercase", letterSpacing:".06em" };
  const card = { background:C.card, borderRadius:"16px", padding:"1.2rem 1.4rem", border:`1.5px solid ${C.border}`, marginBottom:"12px", boxShadow:"0 2px 8px rgba(9,24,77,0.06)" };

  useEffect(() => { cargarDatos(); }, [usuario]); // eslint-disable-line react-hooks/exhaustive-deps

  const cargarDatos = async () => {
    setLoading(true);
    let emp = null;
    try {
      const { data } = await supabase.from("empleados").select("data");
      if (data?.length) {
        const todos = data.map(r => r.data);
        emp = todos.find(e =>
          e.usuario_id === usuario?.id ||
          e.email?.toLowerCase() === usuario?.email?.toLowerCase() ||
          e.nombre?.toLowerCase() === usuario?.nombre?.toLowerCase()
        );
        if (todos.length) localStorage.setItem("alqos_rrhh", JSON.stringify(todos));
      }
    } catch(e) { console.warn(e); }
    if (!emp) {
      const storage = JSON.parse(localStorage.getItem("alqos_rrhh") || "[]");
      emp = storage.find(e =>
        e.usuario_id === usuario?.id ||
        e.email?.toLowerCase() === usuario?.email?.toLowerCase() ||
        e.nombre?.toLowerCase() === usuario?.nombre?.toLowerCase()
      );
    }
    setEmpleado(emp);
    if (emp) {
      const { data: rec } = await supabase
        .from("recibos_sueldo").select("*")
        .eq("legajo", emp.legajo)
        .order("anio", { ascending: false })
        .order("mes",  { ascending: false });
      setRecibos(rec || []);
      setDocs(emp.documentos || []);
      try {
        const { data: coms } = await supabase.from("comunicados").select("data").order("id", { ascending:false });
        const todos = coms ? coms.map(r => r.data) : [];
        setComunicados(todos.filter(c => c.destino==="todos" || c.destino===emp.area));
      } catch(e) { console.warn(e); }
      try {
        const { data: obs } = await supabase.from("onboarding").select("data");
        const mio = (obs||[]).map(r => r.data).find(o => String(o.empleado_id)===String(emp.id) || String(o.usuario_id)===String(usuario?.id));
        setOnboarding(mio || null);
      } catch(e) { console.warn(e); }
    }
    setLoading(false);
  };

  const requiereClave = usuario?.rol !== "Empleado" && usuario?.rol !== "Administrador";

  const hashClave = async (txt) => {
    const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(txt));
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, "0")).join("");
  };

  const crearClave = async () => {
    setErrorClave("");
    if (claveInput.length < 4) { setErrorClave("Minimo 4 caracteres"); return; }
    if (claveInput !== claveConfirm) { setErrorClave("Las claves no coinciden"); return; }
    const h = await hashClave(claveInput);
    const emp2 = { ...empleado, clave_recibos: h };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("empleados").upsert([{ id: emp2.id, data: emp2, tenant_id: tenantId }]); } catch (e) { console.warn(e); }
    const arr = JSON.parse(localStorage.getItem("alqos_rrhh") || "[]");
    const idx = arr.findIndex(e => e.id === emp2.id);
    if (idx >= 0) arr[idx] = emp2; else arr.push(emp2);
    localStorage.setItem("alqos_rrhh", JSON.stringify(arr));
    setEmpleado(emp2);
    setClaveInput(""); setClaveConfirm("");
    setDesbloqueado(true);
  };

  const verificarClave = async () => {
    setErrorClave("");
    const h = await hashClave(claveInput);
    if (h === empleado?.clave_recibos) { setClaveInput(""); setDesbloqueado(true); }
    else setErrorClave("Clave incorrecta");
  };

  const confirmarTareaOnb = async (tareaId) => {
    if (!onboarding) return;
    const tareas = onboarding.tareas.map(t => t.id===tareaId && t.quien==="empleado" ? { ...t, hecho:true, fecha:new Date().toISOString() } : t);
    const upd = { ...onboarding, tareas };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("onboarding").upsert([{ id: onboarding.id, data: upd, tenant_id: tenantId }]); } catch(e) { console.warn(e); }
    setOnboarding(upd);
  };

  const marcarEnterado = async (com) => {
    if (com.acuses?.some(a => a.id === (empleado?.usuario_id||empleado?.id))) return;
    const acuses = [...(com.acuses||[]), { id: empleado?.usuario_id||empleado?.id, nombre: usuario?.nombre, at: new Date().toISOString() }];
    const upd = { ...com, acuses };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("comunicados").upsert([{ id: com.id, data: upd, tenant_id: tenantId }]); } catch(e) { console.warn(e); }
    setComunicados(prev => prev.map(c => c.id===com.id ? upd : c));
  };

  const verPdfComunicado = async (com) => {
    if (!com.pdf_path) return;
    setVerTitulo(com.titulo || "Comunicado"); setCargandoVer(true); setVerUrl(null);
    try {
      const { data, error } = await supabase.storage.from("recibos-sueldo").download(com.pdf_path);
      if (error) throw error;
      setVerUrl(URL.createObjectURL(data));
    } catch(e) { alert("No se pudo abrir el PDF."); setVerTitulo(null); }
    setCargandoVer(false);
  };

  const cerrarVisorPdf = () => {
    if (verUrl) URL.revokeObjectURL(verUrl);
    setVerTitulo(null); setVerUrl(null);
  };

  const notificarRRHH = (recibo, motivo) => {
    guardarNotificacion({
      modulo: "RecursosHumanos",
      tipo: "disconformidad",
      titulo: "Recibo firmado con disconformidad",
      mensaje: `${usuario?.nombre} firmó DISCONFORME el recibo de ${meses[recibo.mes-1]} ${recibo.anio}. Motivo: ${motivo}`,
    });
  };

  const firmarRecibo = async (recibo, conformidad = "conforme", motivo = "") => {
    if (firmando) return;
    if (conformidad === "conforme" && !window.confirm(`¿Confirmás la recepción del recibo de ${meses[recibo.mes-1]} ${recibo.anio}?`)) return;
    setFirmando(recibo.id);
    await supabase.from("recibos_sueldo").update({
      firmado: true,
      firmado_por: usuario?.nombre,
      firmado_at: new Date().toISOString(),
      conformidad,
      motivo_disconformidad: conformidad === "disconforme" ? motivo : null,
    }).eq("id", recibo.id);
    if (conformidad === "disconforme") notificarRRHH(recibo, motivo);
    else guardarNotificacion({ modulo:"RecursosHumanos", tipo:"firma_conforme", titulo:"Recibo firmado conforme", mensaje:`${usuario?.nombre} firmó CONFORME el recibo de ${meses[recibo.mes-1]} ${recibo.anio}.` });
    setDiscId(null); setMotivoDisc("");
    await cargarDatos();
    setFirmando(null);
    if (verUrl) URL.revokeObjectURL(verUrl);
    setVerRecibo(null); setVerUrl(null);
  };

  const confirmarDisconformidad = (recibo) => {
    if (!motivoDisc.trim()) { alert("Escribí el motivo de la disconformidad."); return; }
    firmarRecibo(recibo, "disconforme", motivoDisc.trim());
  };

  const abrirVisor = async (recibo) => {
    setVerRecibo(recibo); setCargandoVer(true); setVerUrl(null);
    setDiscId(null); setMotivoDisc("");
    try {
      const { data, error } = await supabase.storage.from("recibos-sueldo").download(recibo.archivo_path);
      if (error) throw error;
      setVerUrl(URL.createObjectURL(data));
    } catch (e) { console.warn(e); alert("No se pudo cargar el recibo."); }
    setCargandoVer(false);
  };

  const cerrarVisor = () => {
    if (verUrl) URL.revokeObjectURL(verUrl);
    setVerRecibo(null); setVerUrl(null); setDiscId(null); setMotivoDisc("");
  };

  const descargarRecibo = async (path, nombre) => {
    const { data, error } = await supabase.storage.from("recibos-sueldo").download(path);
    if (error) { alert("Error al descargar"); return; }
    const url = URL.createObjectURL(data);
    const a = document.createElement("a"); a.href = url; a.download = nombre; a.click();
    URL.revokeObjectURL(url);
  };

  const subirCertificado = async (archivo) => {
    if (!archivo || !empleado) return;
    if (!formDoc.tipo.trim()) { alert("Escribí el tipo de documento"); return; }
    setSubiendo(true);
    try {
      const path = `certificados/${empleado.legajo}/${Date.now()}_${archivo.name}`;
      const { error: upErr } = await supabase.storage.from("recibos-sueldo").upload(path, archivo, { upsert: true });
      if (upErr) throw upErr;
      const storage = JSON.parse(localStorage.getItem("alqos_rrhh") || "[]");
      const idx = storage.findIndex(e => e.id === empleado.id);
      if (idx >= 0) {
        const nuevoDoc = { id: Date.now(), tipo: formDoc.tipo, descripcion: formDoc.descripcion, vencimiento: formDoc.vencimiento, archivo_path: path, registradoPor: usuario?.nombre, fechaRegistro: new Date().toISOString(), subidoPorEmpleado: true };
        storage[idx].documentos = [...(storage[idx].documentos || []), nuevoDoc];
        localStorage.setItem("alqos_rrhh", JSON.stringify(storage));
        const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
        await supabase.from("empleados").upsert(storage.map(e=>({id:e.id, data:e, tenant_id: tenantId})));
        setDocs(storage[idx].documentos);
      }
      setFormDoc({ tipo:"", descripcion:"", vencimiento:"" });
      alert("✅ Documento subido correctamente");
    } catch(e) { alert("Error: " + e.message); }
    setSubiendo(false);
  };

  const pendientes = recibos.filter(r => !r.firmado);
  const firmados   = recibos.filter(r => r.firmado);

  if (requiereClave && !desbloqueado) {
    const yaTieneClave = !!empleado?.clave_recibos;
    return (
      <div style={{ minHeight:"100vh", background:C.bg, display:"flex", alignItems:"center", justifyContent:"center", padding:"1.5rem", fontFamily:"Inter,sans-serif" }}>
        <div style={{ ...card, maxWidth:"380px", width:"100%", textAlign:"center" }}>
          <div style={{ fontSize:"40px", marginBottom:"8px" }}>🔒</div>
          <div style={{ fontSize:"18px", fontWeight:"800", color:C.navy, marginBottom:"4px" }}>Mis Recibos</div>
          {loading ? (
            <div style={{ color:C.sub, fontSize:"13px", padding:"1rem" }}>Cargando...</div>
          ) : !empleado ? (
            <div style={{ color:C.red, fontSize:"13px", padding:"1rem" }}>No encontramos tu legajo. Habla con RRHH.</div>
          ) : (
            <>
              <div style={{ fontSize:"12px", color:C.sub, marginBottom:"14px" }}>
                {yaTieneClave ? "Ingresa tu clave personal para ver tus recibos" : "Crea una clave personal para proteger tus recibos"}
              </div>
              <input type="password" value={claveInput} onChange={e=>setClaveInput(e.target.value)} placeholder="Clave" style={inp}
                onKeyDown={e=>{ if(e.key==="Enter" && yaTieneClave) verificarClave(); }}/>
              {!yaTieneClave && (
                <input type="password" value={claveConfirm} onChange={e=>setClaveConfirm(e.target.value)} placeholder="Confirmar clave" style={inp}/>
              )}
              {errorClave && <div style={{ color:C.red, fontSize:"12px", marginTop:"8px" }}>{errorClave}</div>}
              <button onClick={yaTieneClave ? verificarClave : crearClave}
                style={{ width:"100%", marginTop:"16px", padding:"11px", borderRadius:"10px", border:"none", background:C.purple, color:"white", fontSize:"14px", fontWeight:"700", cursor:"pointer" }}>
                {yaTieneClave ? "Ingresar" : "Crear clave y entrar"}
              </button>
            </>
          )}
          <button onClick={onVolver || onCerrarSesion}
            style={{ width:"100%", marginTop:"10px", padding:"9px", borderRadius:"10px", border:`1.5px solid ${C.border}`, background:"white", color:C.sub, fontSize:"13px", cursor:"pointer" }}>
            {onVolver ? "← Volver" : "Salir"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:"100vh", background:C.bg, fontFamily:"sans-serif", paddingBottom:"80px" }}>

      {verRecibo && (
        <div style={{ position:"fixed", inset:0, zIndex:1000, background:"rgba(9,24,77,.55)", display:"flex", flexDirection:"column" }}>
          <div style={{ background:C.navy, padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <p style={{ color:"white", fontWeight:"800", fontSize:"15px", margin:0 }}>Recibo {meses[verRecibo.mes-1]} {verRecibo.anio}</p>
              <p style={{ color:"rgba(255,255,255,.55)", fontSize:"11px", margin:"2px 0 0" }}>Revisalo antes de firmar</p>
            </div>
            <button onClick={cerrarVisor} style={{ background:"rgba(255,255,255,.12)", border:"1px solid rgba(255,255,255,.25)", color:"white", padding:"7px 14px", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>✕ Cerrar</button>
          </div>

          <div style={{ flex:1, background:"#525659", overflow:"auto", display:"flex", alignItems:"center", justifyContent:"center" }}>
            {cargandoVer && <span style={{ color:"white", fontSize:"14px" }}>⏳ Cargando recibo...</span>}
            {!cargandoVer && verUrl && <iframe title="recibo" src={verUrl} style={{ width:"100%", height:"100%", border:"none" }}/>}
          </div>

          <div style={{ background:"white", padding:"18px", borderTop:`1px solid ${C.border}` }}>
            {verRecibo.firmado ? (
              <div style={{ display:"flex", gap:"12px", maxWidth:"600px", margin:"0 auto" }}>
                <button onClick={() => descargarRecibo(verRecibo.archivo_path, `Recibo_${meses[verRecibo.mes-1]}_${verRecibo.anio}.pdf`)}
                  style={{ flex:1, padding:"13px", background:C.blue, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"700", fontSize:"14px" }}>
                  📥 Descargar
                </button>
                <button onClick={cerrarVisor}
                  style={{ flex:1, padding:"13px", background:"white", color:C.sub, border:`1.5px solid ${C.border}`, borderRadius:"10px", cursor:"pointer", fontWeight:"700", fontSize:"14px" }}>
                  Cerrar
                </button>
              </div>
            ) : discId !== verRecibo.id ? (
              <>
                <p style={{ textAlign:"center", fontSize:"14px", fontWeight:"700", color:C.navy, margin:"0 0 14px" }}>¿Estás conforme con el recibo?</p>
                <div style={{ display:"flex", gap:"12px", maxWidth:"600px", margin:"0 auto" }}>
                  <button onClick={() => firmarRecibo(verRecibo, "conforme")} disabled={!!firmando}
                    style={{ flex:1, padding:"16px", background:"white", color:C.green, border:`2px solid ${C.green}`, borderRadius:"14px", cursor:"pointer", fontWeight:"700", fontSize:"15px" }}>
                    <div style={{ fontSize:"26px", marginBottom:"4px" }}>🙂</div>
                    {firmando===verRecibo.id ? "⏳..." : "Firmar conforme"}
                  </button>
                  <button onClick={() => { setDiscId(verRecibo.id); setMotivoDisc(""); }} disabled={!!firmando}
                    style={{ flex:1, padding:"16px", background:"white", color:C.purple, border:`2px solid ${C.purple}`, borderRadius:"14px", cursor:"pointer", fontWeight:"700", fontSize:"15px" }}>
                    <div style={{ fontSize:"26px", marginBottom:"4px" }}>🙁</div>
                    Firmar en disconformidad
                  </button>
                </div>
              </>
            ) : (
              <div style={{ maxWidth:"600px", margin:"0 auto" }}>
                <p style={{ fontSize:"13px", fontWeight:"700", color:C.purple, margin:"0 0 8px" }}>Motivo de la disconformidad (obligatorio)</p>
                <textarea value={motivoDisc} onChange={e=>setMotivoDisc(e.target.value)} rows={3}
                  placeholder="Ej: diferencia en horas extras, descuento no reconocido..."
                  style={{ width:"100%", padding:"10px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"13px", boxSizing:"border-box", resize:"vertical", fontFamily:"sans-serif", color:C.text, outline:"none" }}/>
                <div style={{ display:"flex", gap:"10px", marginTop:"10px" }}>
                  <button onClick={() => confirmarDisconformidad(verRecibo)} disabled={!!firmando}
                    style={{ flex:1, padding:"13px", background:C.purple, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"700", fontSize:"14px" }}>
                    Confirmar firma con disconformidad
                  </button>
                  <button onClick={() => { setDiscId(null); setMotivoDisc(""); }}
                    style={{ padding:"13px 18px", background:"white", color:C.sub, border:`1.5px solid ${C.border}`, borderRadius:"10px", cursor:"pointer", fontSize:"14px" }}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* HEADER */}
      <div style={{ background:`linear-gradient(135deg, ${C.navy}, #1a2f7a)`, padding:"1.2rem 1.5rem 1.5rem" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:"8px", marginBottom:"8px" }}>
              <span style={{ color:"white", fontWeight:"800", fontSize:"15px" }}>ALQOS™</span>
              <span style={{ background:"rgba(255,255,255,.15)", color:"rgba(255,255,255,.7)", fontSize:"9px", padding:"2px 8px", borderRadius:"8px", fontWeight:"600" }}>HUMAN CAPITAL</span>
            </div>
            <p style={{ color:"rgba(255,255,255,.6)", fontSize:"12px", margin:"0 0 3px" }}>Bienvenido/a</p>
            <h2 style={{ color:"white", fontSize:"20px", fontWeight:"800", margin:"0 0 3px" }}>{usuario?.nombre}</h2>
            {empleado && <p style={{ color:"rgba(255,255,255,.55)", fontSize:"11px", margin:0 }}>{empleado.puesto} · {empleado.area} · {empleado.legajo}</p>}
          </div>
          <button onClick={onVolver || onCerrarSesion} style={{ background:"rgba(255,255,255,.1)", border:"1px solid rgba(255,255,255,.2)", color:"white", padding:"6px 12px", borderRadius:"8px", cursor:"pointer", fontSize:"11px" }}>
            {onVolver ? "← Volver" : "Salir"}
          </button>
        </div>
        {pendientes.length > 0 && (
          <div style={{ marginTop:"14px", background:"rgba(245,158,11,.2)", border:"1px solid rgba(245,158,11,.5)", borderRadius:"10px", padding:"10px 14px", display:"flex", alignItems:"center", gap:"8px" }}>
            <span style={{ fontSize:"18px" }}>⚠️</span>
            <div>
              <p style={{ color:"#fcd34d", fontSize:"12px", fontWeight:"700", margin:0 }}>Tenés {pendientes.length} pendiente{pendientes.length>1?"s":""} de firma</p>
              <p style={{ color:"rgba(255,255,255,.5)", fontSize:"10px", margin:"2px 0 0" }}>Revisalos en Mis Pendientes</p>
            </div>
          </div>
        )}
      </div>

      {/* CONTENIDO */}
      <div style={{ padding:"1.2rem 1.2rem 0", maxWidth:"600px", margin:"0 auto" }}>

        {loading && <div style={{ textAlign:"center", padding:"4rem", color:C.sub }}>⏳ Cargando tu información...</div>}

        {!loading && !empleado && (
          <div style={{ ...card, textAlign:"center", padding:"3rem", marginTop:"1rem" }}>
            <p style={{ fontSize:"40px" }}>👤</p>
            <p style={{ fontSize:"14px", fontWeight:"700", color:C.navy }}>Perfil no vinculado</p>
            <p style={{ fontSize:"12px", color:C.sub }}>Pedile al área de RRHH que vincule tu usuario con tu legajo</p>
          </div>
        )}

        {/* MIS PENDIENTES */}
        {!loading && empleado && seccion === "pendientes" && (
          <>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.navy, margin:"0 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>
              📋 Pendientes de firma {pendientes.length > 0 && <span style={{ background:C.red, color:"white", borderRadius:"50%", fontSize:"10px", padding:"1px 6px", marginLeft:"6px" }}>{pendientes.length}</span>}
            </h3>
            {pendientes.length === 0 && (
              <div style={{ ...card, textAlign:"center", padding:"2.5rem" }}>
                <p style={{ fontSize:"32px" }}>✅</p>
                <p style={{ color:C.sub, fontSize:"13px" }}>Todo al día, sin pendientes</p>
              </div>
            )}
            {pendientes.map(r => (
              <div key={r.id} style={{ ...card, border:`1.5px solid ${C.amber}60`, background:"#fffbeb" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <p style={{ fontSize:"14px", fontWeight:"700", color:C.amber, margin:"0 0 3px" }}>⏳ {meses[r.mes-1]} {r.anio}</p>
                    <p style={{ fontSize:"11px", color:C.sub, margin:0 }}>{r.observaciones || "Recibo de sueldo"}</p>
                  </div>
                  <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
                    <button onClick={() => abrirVisor(r)}
                      style={{ padding:"7px 12px", background:C.blue, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                      👁 Ver y firmar
                    </button>
                    <button onClick={() => firmarRecibo(r, "conforme")} disabled={!!firmando}
                      style={{ padding:"7px 12px", background:firmando===r.id?"#808085":C.green, color:"white", border:"none", borderRadius:"8px", cursor:firmando?"wait":"pointer", fontSize:"11px", fontWeight:"600" }}>
                      {firmando===r.id ? "⏳..." : "✓ Conforme"}
                    </button>
                    <button onClick={() => { setDiscId(discId===r.id?null:r.id); setMotivoDisc(""); }} disabled={!!firmando}
                      style={{ padding:"7px 12px", background:"white", color:C.amber, border:`1.5px solid ${C.amber}`, borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                      ⚠ Disconforme
                    </button>
                  </div>
                </div>
                {discId===r.id && (
                  <div style={{ marginTop:"12px", paddingTop:"12px", borderTop:`1px solid ${C.amber}40` }}>
                    <p style={{ fontSize:"11px", fontWeight:"700", color:C.amber, margin:"0 0 6px" }}>Motivo de la disconformidad (obligatorio)</p>
                    <textarea value={motivoDisc} onChange={e=>setMotivoDisc(e.target.value)} rows={3}
                      placeholder="Ej: diferencia en horas extras, descuento no reconocido..."
                      style={{ width:"100%", padding:"10px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"12px", boxSizing:"border-box", resize:"vertical", fontFamily:"sans-serif", color:C.text, outline:"none" }}/>
                    <div style={{ display:"flex", gap:"8px", marginTop:"8px" }}>
                      <button onClick={() => confirmarDisconformidad(r)} disabled={!!firmando}
                        style={{ flex:1, padding:"9px", background:C.amber, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"700" }}>
                        Firmar con disconformidad
                      </button>
                      <button onClick={() => { setDiscId(null); setMotivoDisc(""); }}
                        style={{ padding:"9px 14px", background:"white", color:C.sub, border:`1.5px solid ${C.border}`, borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
            {firmados.length > 0 && (
              <>
                <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.sub, margin:"20px 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>Firmados</h3>
                {firmados.map(r => (
                  <div key={r.id} style={{ ...card, border:`1.5px solid ${C.green}40`, background:"#f0fdf4" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <div>
                        <p style={{ fontSize:"13px", fontWeight:"700", color: r.conformidad==="disconforme"?C.amber:C.green, margin:"0 0 3px" }}>
                          {r.conformidad==="disconforme" ? "⚠ " : "✅ "}{meses[r.mes-1]} {r.anio}
                          {r.conformidad==="disconforme" && <span style={{ fontSize:"9px", background:C.amber, color:"white", borderRadius:"6px", padding:"1px 6px", marginLeft:"6px", fontWeight:"700" }}>CON OBJECIÓN</span>}
                        </p>
                        <p style={{ fontSize:"11px", color:C.sub, margin:0 }}>Firmado el {new Date(r.firmado_at).toLocaleDateString("es-AR")}</p>
                        {r.conformidad==="disconforme" && r.motivo_disconformidad && <p style={{ fontSize:"11px", color:C.amber, margin:"4px 0 0", fontStyle:"italic" }}>Motivo: {r.motivo_disconformidad}</p>}
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
                        <button onClick={() => abrirVisor(r)}
                          style={{ padding:"6px 10px", background:C.blue, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                          👁 Ver
                        </button>
                        <button onClick={() => descargarRecibo(r.archivo_path, `Recibo_${meses[r.mes-1]}_${r.anio}.pdf`)}
                          style={{ padding:"6px 10px", background:"white", color:C.blue, border:`1.5px solid ${C.blue}`, borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                          📥 Descargar
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}

        {/* MIS DOCUMENTOS */}
        {!loading && empleado && seccion === "documentos" && (
          <>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.navy, margin:"0 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>📁 Mis Documentos</h3>
            {docs.length === 0
              ? <div style={{ ...card, textAlign:"center", padding:"2.5rem" }}><p style={{ fontSize:"32px" }}>📁</p><p style={{ color:C.sub }}>Sin documentos todavía</p></div>
              : [...docs].reverse().map((doc, i) => (
                  <div key={doc.id||i} style={card}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div style={{ flex:1 }}>
                        <p style={{ fontSize:"13px", fontWeight:"700", color:C.purple, margin:"0 0 3px" }}>
                          {doc.subidoPorEmpleado ? "📤" : "📎"} {doc.tipo}
                        </p>
                        {doc.descripcion && <p style={{ fontSize:"11px", color:C.sub, margin:"2px 0" }}>{doc.descripcion}</p>}
                        <p style={{ fontSize:"10px", color:C.sub, margin:0 }}>
                          {doc.subidoPorEmpleado ? "Subido por vos" : "Cargado por RRHH"} · {new Date(doc.fechaRegistro).toLocaleDateString("es-AR")}
                        </p>
                      </div>
                      {doc.vencimiento && (
                        <span style={{ fontSize:"11px", fontWeight:"700", color:C.amber, background:"#fffbeb", padding:"3px 8px", borderRadius:"6px", border:`1px solid ${C.amber}40`, flexShrink:0, marginLeft:"8px" }}>
                          Vence {doc.vencimiento}
                        </span>
                      )}
                    </div>
                    {doc.archivo_path && (
                      <div style={{ display:"flex", gap:"8px", marginTop:"10px" }}>
                        <button onClick={()=>verPdfComunicado({ pdf_path:doc.archivo_path, titulo:doc.tipo })} style={{ padding:"7px 12px", background:C.blue, color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>👁 Ver</button>
                        <button onClick={()=>descargarRecibo(doc.archivo_path, `${doc.tipo}.pdf`)} style={{ padding:"7px 12px", background:"white", color:C.blue, border:`1.5px solid ${C.blue}`, borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>📥 Descargar</button>
                      </div>
                    )}
                  </div>
                ))
            }
          </>
        )}

        {/* SUBIR DOCUMENTO */}
        {!loading && empleado && seccion === "subir" && (
          <>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.navy, margin:"0 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>📤 Subir Documento</h3>
            <div style={card}>
              <p style={{ fontSize:"12px", color:C.sub, marginBottom:"4px" }}>Subí tus certificados, libretas sanitarias, carnets u otros documentos personales.</p>
              <span style={lbl}>Tipo de documento *</span>
              <input value={formDoc.tipo} onChange={e=>setFormDoc(f=>({...f,tipo:e.target.value}))} style={inp} placeholder="Ej: Libreta sanitaria, Certificado de capacitación"/>
              <span style={lbl}>Descripción</span>
              <input value={formDoc.descripcion} onChange={e=>setFormDoc(f=>({...f,descripcion:e.target.value}))} style={inp} placeholder="Detalle adicional (opcional)"/>
              <span style={lbl}>Fecha de vencimiento</span>
              <input type="date" value={formDoc.vencimiento} onChange={e=>setFormDoc(f=>({...f,vencimiento:e.target.value}))} style={inp}/>
              <span style={lbl}>Archivo (PDF o imagen) *</span>
              <input type="file" accept="application/pdf,image/*" onChange={e=>e.target.files[0]&&subirCertificado(e.target.files[0])}
                style={{...inp, padding:"8px", cursor:"pointer"}}/>
              {subiendo && (
                <div style={{ marginTop:"12px", textAlign:"center", padding:"12px", background:"#eff6ff", borderRadius:"10px" }}>
                  <p style={{ color:C.blue, fontSize:"13px", fontWeight:"600" }}>⏳ Subiendo documento...</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {!loading && empleado && seccion === "comunicados" && (
        <div style={{ padding:"1.2rem 1.2rem 0", maxWidth:"600px", margin:"0 auto" }}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.navy, margin:"0 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>📢 Comunicados</h3>
          {comunicados.length===0 && (
            <div style={{ ...card, textAlign:"center", padding:"2.5rem" }}><p style={{ fontSize:"32px" }}>📭</p><p style={{ color:C.sub, fontSize:"13px" }}>Sin comunicados</p></div>
          )}
          {comunicados.map(c => {
            const yo = empleado?.usuario_id||empleado?.id;
            const enterado = c.acuses?.some(a => a.id === yo);
            return (
              <div key={c.id} style={{ ...card, border:`1.5px solid ${enterado?C.green:C.purple}40` }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <p style={{ fontSize:"14px", fontWeight:"700", color:C.navy, margin:"0 0 6px" }}>{c.titulo}</p>
                  {c.pdf_path && <button onClick={()=>verPdfComunicado(c)} style={{ fontSize:"11px", background:C.blue, color:"white", border:"none", borderRadius:"8px", padding:"5px 10px", cursor:"pointer", fontWeight:"600" }}>📎 Ver PDF</button>}
                </div>
                <p style={{ fontSize:"13px", color:C.text, margin:"0 0 10px", whiteSpace:"pre-wrap" }}>{c.mensaje}</p>
                <p style={{ fontSize:"11px", color:C.sub, margin:"0 0 10px" }}>{c.publicado_por} · {new Date(c.publicado_at).toLocaleDateString("es-AR")}</p>
                {enterado
                  ? <span style={{ fontSize:"12px", color:C.green, fontWeight:"700" }}>✓ Enterado</span>
                  : <button onClick={()=>marcarEnterado(c)} style={{ width:"100%", padding:"10px", background:C.green, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"13px", fontWeight:"700" }}>✓ Marcar como enterado</button>
                }
              </div>
            );
          })}
        </div>
      )}

      {!loading && empleado && seccion === "onboarding" && (
        <div style={{ padding:"1.2rem 1.2rem 0", maxWidth:"600px", margin:"0 auto" }}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.navy, margin:"0 0 12px", textTransform:"uppercase", letterSpacing:".08em" }}>🚀 Mi Onboarding</h3>
          {!onboarding ? (
            <div style={{ ...card, textAlign:"center", padding:"2.5rem" }}><p style={{ fontSize:"32px" }}>✅</p><p style={{ color:C.sub, fontSize:"13px" }}>No tenés tareas de ingreso pendientes</p></div>
          ) : (() => {
            const total = onboarding.tareas.length, hechas = onboarding.tareas.filter(t=>t.hecho).length;
            const pct = Math.round(hechas/total*100);
            return (
              <div style={card}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"8px" }}>
                  <span style={{ fontSize:"13px", fontWeight:"700", color:C.navy }}>Progreso</span>
                  <span style={{ fontSize:"13px", fontWeight:"700", color:pct===100?C.green:C.amber }}>{pct}%</span>
                </div>
                <div style={{ height:"6px", background:C.border, borderRadius:"3px", marginBottom:"14px", overflow:"hidden" }}>
                  <div style={{ width:`${pct}%`, height:"100%", background:pct===100?C.green:C.purple }}/>
                </div>
                {onboarding.tareas.map(t => (
                  <div key={t.id} style={{ display:"flex", alignItems:"center", gap:"8px", padding:"8px 0", borderBottom:`0.5px solid ${C.border}` }}>
                    {t.quien==="empleado" ? (
                      <button onClick={()=>!t.hecho&&confirmarTareaOnb(t.id)} disabled={t.hecho}
                        style={{ width:"22px", height:"22px", borderRadius:"6px", border:`1.5px solid ${t.hecho?C.green:C.purple}`, background:t.hecho?C.green:"transparent", color:"white", cursor:t.hecho?"default":"pointer", fontSize:"12px", flexShrink:0 }}>{t.hecho?"✓":""}</button>
                    ) : (
                      <span style={{ width:"22px", height:"22px", borderRadius:"6px", border:`1.5px solid ${t.hecho?C.green:C.border}`, background:t.hecho?C.green:"transparent", display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontSize:"12px", flexShrink:0 }}>{t.hecho?"✓":""}</span>
                    )}
                    <span style={{ fontSize:"13px", color:t.hecho?C.sub:C.text, textDecoration:t.hecho?"line-through":"none", flex:1 }}>{t.t}</span>
                    <span style={{ fontSize:"9px", color:C.sub, background:t.quien==="rrhh"?"#eff6ff":"#f0fdf4", padding:"2px 6px", borderRadius:"5px" }}>{t.quien==="rrhh"?"RRHH":"Vos"}</span>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      )}

      {verTitulo && (
        <div style={{ position:"fixed", inset:0, zIndex:1000, background:"rgba(9,24,77,.55)", display:"flex", flexDirection:"column" }}>
          <div style={{ background:C.navy, padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <p style={{ color:"white", fontWeight:"800", fontSize:"15px", margin:0 }}>{verTitulo}</p>
            <button onClick={cerrarVisorPdf} style={{ background:"rgba(255,255,255,.12)", border:"1px solid rgba(255,255,255,.25)", color:"white", padding:"7px 14px", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>✕ Cerrar</button>
          </div>
          <div style={{ flex:1, background:"#525659", overflow:"auto", display:"flex", alignItems:"center", justifyContent:"center" }}>
            {cargandoVer && <span style={{ color:"white", fontSize:"14px" }}>⏳ Cargando...</span>}
            {!cargandoVer && verUrl && <iframe title="pdf" src={verUrl} style={{ width:"100%", height:"100%", border:"none" }}/>}
          </div>
          <div style={{ background:"white", padding:"14px 18px", display:"flex", gap:"10px", justifyContent:"center" }}>
            {verUrl && <a href={verUrl} download={`${verTitulo}.pdf`} style={{ padding:"11px 20px", background:C.blue, color:"white", borderRadius:"10px", textDecoration:"none", fontWeight:"700", fontSize:"14px" }}>📥 Descargar</a>}
          </div>
        </div>
      )}

      {/* BARRA INFERIOR — estilo Humanage */}
      <div style={{ position:"fixed", bottom:0, left:0, right:0, background:"white", borderTop:`1.5px solid ${C.border}`, display:"flex", zIndex:100, boxShadow:"0 -4px 16px rgba(9,24,77,0.08)" }}>
        {[
          ["pendientes",  "📋", "Pendientes",   pendientes.length],
          ["comunicados", "📢", "Avisos",       comunicados.filter(c=>!c.acuses?.some(a=>a.id===(empleado?.usuario_id||empleado?.id))).length],
          ["onboarding",  "🚀", "Ingreso",      onboarding?onboarding.tareas.filter(t=>t.quien==="empleado"&&!t.hecho).length:0],
          ["documentos",  "📁", "Documentos",   0],
          ["subir",       "📤", "Subir doc",     0],
        ].map(([key, icon, label, badge]) => (
          <button key={key} onClick={() => setSeccion(key)}
            style={{ flex:1, padding:"12px 8px", border:"none", background:"none", cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:"3px", borderTop:seccion===key?`3px solid ${C.purple}`:"3px solid transparent", position:"relative" }}>
            {badge > 0 && <span style={{ position:"absolute", top:"6px", right:"calc(50% - 14px)", background:C.red, color:"white", borderRadius:"50%", fontSize:"9px", padding:"1px 5px", fontWeight:"700" }}>{badge}</span>}
            <span style={{ fontSize:"18px" }}>{icon}</span>
            <span style={{ fontSize:"10px", fontWeight:seccion===key?"700":"500", color:seccion===key?C.purple:C.sub }}>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
